// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3jlok","consentsList":"PatientConsents_consentsList__YqLZO","consentsListEmpty":"PatientConsents_consentsListEmpty__3-vrR"};